import React from 'react';
import LogoMain from '../../assets/logoMain';
import { Row, Col } from 'reactstrap'
import PhoneIcon from '../../assets/PhoneIcon';
import ShareIcon from '../../assets/ShareIcon';
import ArrowRight from '../../assets/ArrowRight';
import './index.scss'
import { Dialog, DialogContent } from '@material-ui/core';


const CommonModal = (props) => {
    return (
        <Dialog
            open={props.open}
            maxWidth={props.maxWidth || "sm"}
            // onClose={props.handleClose()}
            aria-labelledby="form-dialog-title"
            {...props}
            >
            <DialogContent>
                {props.children}
            </DialogContent>
        </Dialog>
    );
}
export default CommonModal